import { useEffect, useRef, useState, ReactNode } from 'react';
import { Portal } from '@mui/material';

interface RenderInWindowProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  children: ReactNode;
}

const RenderInWindow = ({ open, setOpen, children }: RenderInWindowProps) => {
  const newWindow = useRef<Window | null>(null);
  const [ready, setReady] = useState(false);

  const injectStyles = (targetWindow: Window, styles: string) => {
    const styleEl = targetWindow.document.createElement('style');
    styleEl.textContent = styles;
    targetWindow.document.head.appendChild(styleEl);
  };

  useEffect(() => {
    if (open) {
      newWindow.current = window.open(
        '',
        '',
        'width=600,height=400,left=200,top=200'
      );

      const curWindow = newWindow.current;

      if (curWindow?.document) {
        curWindow.document.body.appendChild(
          curWindow.document.createElement('div')
        );

        const styles = `
          body {
            background-color: black;
            font-family: Arial, sans-serif;
            color: white;
          }
          .new-window-list {
            list-style-type: none;
            padding-inline-start: 0;
          }
          .new-window-list li {
            padding-left: 1.5em;
            text-indent: -1.5em;
          }
        `;

        injectStyles(curWindow, styles);

        curWindow.onbeforeunload = () => {
          setReady(false);
          setOpen(false);
        };

        setReady(true);
      }
    }

    return () => {
      if (newWindow.current) {
        newWindow.current.onbeforeunload = null;
        newWindow.current.close();
        setReady(false);
      }
    };
  }, [open, setOpen]);

  if (open && ready && newWindow.current?.document) {
    return (
      <Portal container={newWindow.current.document.body}>{children}</Portal>
    );
  }
  return null;
};

export default RenderInWindow;
